import { Component, Input, OnInit } from '@angular/core';
import { NgModel } from '@angular/forms';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { SalaryPartnerModel } from './salary-partner-model';
import { SalaryModel } from './salary.model';
import { SalaryDetailModel } from './salaryDetail.model';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-salary',
  templateUrl: './salary.component.html',
  styleUrls: ['./salary.component.css'],
})
export class SalaryComponent implements OnInit {
  financialList;
  branchList;
  designationList;
  closingDateList;
  selectedFinancialYear;
  selectedBranches: any[];
  selectedProfile = '1';
  selectedClosing;
  userId;
  selectedDesignation: any[];
  @Input() reportList: SalaryPartnerModel[];
  @Input() myReportIndicator: boolean;
  monthvalue = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  isAllDesignate: boolean;
  isAllBranch: boolean;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService, private commonMessageService: CommonMessageService,
    private branchFilterService: BranchFilterService
  ) { }

  ngOnInit(): void {
    this.selectedClosing = '';
    this.selectedFinancialYear = '';
    this.selectedBranches = [];
    this.selectedDesignation = [];
    console.log('myReportIndicator', this.myReportIndicator);
    this.loadFinancialDetails();
  }
  loadFinancialDetails() {
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });

    this.masterDataService.getDesignations().subscribe((res) => {
      this.designationList = res;
    });
  }

  showExportToExcelButton = false;
  showReportDetails: boolean;
  onViewReport() {
    if (
      this.selectedBranches === null ||
      this.selectedBranches == undefined ||
      this.selectedBranches.length === 0 ||
      this.selectedClosing == null ||
      this.selectedClosing == undefined ||
      this.selectedClosing == '' ||
      this.selectedProfile == null ||
      this.selectedProfile == undefined ||
      this.selectedDesignation == null ||
      this.selectedDesignation.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose all the values');
      return;
    }
    this.userId = 0;
    this.masterDataService
      .getSalaryReport(
        this.selectedBranches,
        this.selectedClosing,
        this.selectedProfile,
        this.selectedDesignation,
        this.userId
      )
      .subscribe((res: any) => {
        this.reportList = res;
        // this.showExportToExcelButton=true;
        console.log('reportList', this.reportList);
        if (this.reportList.length == 0) {
          this.commonMessageService.swalAlertWithoutIcon('', 'No record found.');
          this.showExportToExcelButton = false;
          this.showReportDetails = false;
        } else {
          this.showExportToExcelButton = true;
          this.showReportDetails = true;
        }
      });
  }

  getMonth(month: number) {
    return this.monthvalue[month - 1];
  }
  getTotalSalary(salary: SalaryModel) {
    let total: number = 0;
    salary.salaryDetails.map((res: any) => {
      total += res.total;
    });
    var alltotal = Math.round(total);
    return alltotal;
  }
  getTotal(salary: SalaryDetailModel) {
    return salary.total;
  }
  onFinancialYearSlected() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          console.log('this.closingDateList', this.closingDateList);
        });
    }
  }

  getCreditHours(hours, mins) {
    var calculatedmin;
    var calculatedHrs = hours;
    var calculatedHrsMin;

    if (mins >= 60) {
      // calculatedHrs = Math.floor(mins / 60);
      // calculatedmin = mins / 60;
      // calculatedmin = calculatedmin - calculatedHrs;
      // calculatedHrs = calculatedHrs + hours;
      calculatedmin = Math.trunc(mins / 60) + (mins % 60) / 100;
      console.log('calculated min', calculatedmin);
      calculatedHrsMin = (calculatedHrs + calculatedmin);
    } else {
      calculatedHrsMin = calculatedHrs + '.' + mins;
    }
    if (hours == 0 && mins == 0) {
      calculatedHrsMin = 0;
    }
    return calculatedHrsMin;
  }



  // getCreditDebitHours(creditHrs, creditMins, debitHrs, debitMins) {
  //   // var convertCreditHoursToMins;
  //   // var convertDebitHoursToMins;
  //   var convertCreditHoursToMins = creditHrs * 60;
  //   var convertDebitHoursToMins = debitHrs * 60;
  //   // var claculateCreditMin;
  //   // var claculateDebitMin;
  //   var claculateCreditMin = (convertCreditHoursToMins + creditMins);
  //   var claculateDebitMin = (convertDebitHoursToMins + debitMins);
  //   // var calculationForCreditDebitMin;
  //   var calculationForCreditDebitMin = (claculateCreditMin - claculateDebitMin);
  //   // var finalCalculationForCreditDebitHrs;
  //   var finalCalculationForCreditDebitHrs;
  //   finalCalculationForCreditDebitHrs = Math.trunc(calculationForCreditDebitMin / 60) + (calculationForCreditDebitMin % 60) / 100;
  //   if (debitHrs == 0 && debitMins == 0) {
  //     finalCalculationForCreditDebitHrs = creditHrs + '.' + creditMins;
  //   }
  //   return finalCalculationForCreditDebitHrs;
  // }

  getCreditDebitHours(creditHrs, creditMins, debitHrs, debitMins) {
    console.log('creditHrs, creditMins, debitHrs, debitMins', creditHrs, creditMins, debitHrs, debitMins);

    if (creditHrs == 0 && creditMins == 0 && debitHrs == 0 && debitMins == 0) {
      finalCalculationForCreditDebitHrs = 0;
    } else if (creditHrs == 0 && creditMins == 0) {
      if (debitMins >= 60) {
        var calculateMin;
        calculateMin = Math.trunc(debitMins / 60) + (debitMins % 60) / 100;
        console.log('calculateMin', calculateMin);
        if (calculateMin == 0) {
          finalCalculationForCreditDebitHrs = 0;
        } else {
          finalCalculationForCreditDebitHrs = '-' + (debitHrs + calculateMin);
        }
      } else {
        finalCalculationForCreditDebitHrs = '-' + debitHrs + '.' + debitMins;
      }
    } else {
      var calculateDebitCreditHr = (creditHrs - debitHrs);
      var calculateDebitCreditMin = (creditMins - debitMins);
      var finalCalculationForCreditDebitHrs;
      console.log('.........', calculateDebitCreditHr, calculateDebitCreditMin);
      if (calculateDebitCreditMin >= 60) {
        var calculateMin;
        calculateMin = Math.trunc(calculateDebitCreditMin / 60) + (calculateDebitCreditMin % 60) / 100;
        console.log('calculateMin', calculateMin);
        finalCalculationForCreditDebitHrs = (calculateDebitCreditHr + calculateMin);
      } else {
        finalCalculationForCreditDebitHrs = calculateDebitCreditHr + '.' + Math.abs(calculateDebitCreditMin);
      }
    }
    return finalCalculationForCreditDebitHrs;
  }

  selectAll(select: NgModel, values) {
    const isDesignation = select.name === 'designateSelect';
    let isAll = isDesignation ? this.isAllDesignate : this.isAllBranch;

    let ids = [];
    if (!isAll) {
      for (let i = 0; i < values.length; i++) {
        ids.push(values[i].id);
      }
    }
    select.update.emit(ids);

    if (isDesignation) {
      this.isAllDesignate = !this.isAllDesignate;
    } else {
      this.isAllBranch = !this.isAllBranch;
    }
  }

  exportToExcelClick() {
    this.userId = 0;
    this.masterDataService
      .getSalaryReportExportToExcel(
        this.selectedBranches,
        this.selectedClosing,
        this.selectedProfile,
        this.selectedDesignation,
        this.userId
      )
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "SalaryReport.xlsx";
        link.click();
      });
  }

  getAbs(value: number): number {
  return Math.abs(value);
}
}
